import type { FC, SVGProps } from 'react'

export const Reverb: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.125 12C16.125 14.2091 14.3341 16 12.125 16C9.91586 16 8.125 14.2091 8.125 12C8.125 9.79086 9.91586 8 12.125 8C14.3341 8 16.125 9.79086 16.125 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.125 17.5C15.1626 17.5 17.625 15.0376 17.625 12C17.625 8.96243 15.1626 6.5 12.125 6.5C9.08743 6.5 6.625 8.96243 6.625 12C6.625 15.0376 9.08743 17.5 12.125 17.5ZM12.125 19C15.991 19 19.125 15.866 19.125 12C19.125 8.13401 15.991 5 12.125 5C8.25901 5 5.125 8.13401 5.125 12C5.125 15.866 8.25901 19 12.125 19Z"
      fill="currentColor"
      fillOpacity="0.7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.125 20.5C16.8194 20.5 20.625 16.6944 20.625 12C20.625 7.30558 16.8194 3.5 12.125 3.5C7.43058 3.5 3.625 7.30558 3.625 12C3.625 16.6944 7.43058 20.5 12.125 20.5ZM12.125 22C17.6478 22 22.125 17.5228 22.125 12C22.125 6.47715 17.6478 2 12.125 2C6.60215 2 2.125 6.47715 2.125 12C2.125 17.5228 6.60215 22 12.125 22Z"
      fill="currentColor"
      fillOpacity="0.5"
    />
  </svg>
)
